/**
 * Pill overlay rendered on a remote attendee's avatar tile when the SDK's
 * downlink policy paused that tile under bandwidth pressure (`tile state
 * === 'bandwidth_suppressed'`). Communicates that audio is still flowing
 * but video has been suppressed to preserve the link.
 *
 * Sibling to `VideoMeetingTileAudioIcon` and `VideoMeetingTileConnectionIcon`.
 * Positioned at top-left so it doesn't collide with the audio icon
 * (bottom-right) or the connection icon. Local self-view tiles never
 * render this — see `VideoMeetingTile`.
 */
export function VideoMeetingTileBandwidthPill() {
  return (
    <div
      role="status"
      aria-label="Video reception limited due to network bandwidth"
      className="absolute top-1 left-1 px-2 py-1 rounded-md bg-brand-900/90 backdrop-blur text-brand-100 text-xs font-medium"
    >
      Limited video reception
    </div>
  );
}

export default VideoMeetingTileBandwidthPill;
